/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Top_Center_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Top center" |
*
* @param {Position_Top_Center_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_top_center_aria_label = /** @type {((inputs?: Position_Top_Center_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Top_Center_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En haut au centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Oben Mitte")
	if (locale === "it") return /** @type {LocalizedString} */ ("In alto al centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Верхний центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro superior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("顶部中心")
	if (locale === "ja") return /** @type {LocalizedString} */ ("上中央")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शीर्ष केंद्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro superior")
	return /** @type {LocalizedString} */ ("Top center")
});